import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'components_v2/common/Dropdown/DropdownLoader';
import LinkList from 'components_v2/common/LinkList';
import InViewObserver from 'components/InViewObserver';
import makeRequest from 'utils/makeRequest';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import CardListV5 from 'components_v2/common/CardListV5';
import Card from 'components_v2/common/CardV2';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import GadgetCard from 'components_v2/common/GadgetCard/GadgetCardLoader';
import IFrameWdt from 'components_v2/common/IFrameWdt';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import _get from 'lodash.get';
import s from './TechSection.scss';
import Listingheader from '../../common/ListingheaderV2';
import AffiliateWidgetMain from '../../../../articleshow/components/AffiliateWidget/AffiliateWidgetMain';
import HeaderTab from '../HeaderTabV2';
import CityModal from '../CityModal/CityModalLoader';
import CompareWidget from '../CompareWidget';
import Infocus from '../Infocus';

class TechSection extends React.Component {
  constructor() {
    super();
    this.state = {
      shouldshowModal: false,
    };
  }

  loadSection = () => {
    const { sectionData } = this.props;
    //for loading content
    if (sectionData && !Array.isArray(sectionData) && sectionData.dataUrl) {
      this.loadSectionData(sectionData.dataUrl);
    }
  };

  loadNavigationData() {
    const { sectionData = {} } = this.props;
    if (sectionData.subSections && sectionData.subSections.dataUrl) {
      this.loadHeaderData(sectionData.subSections.dataUrl);
    }
  }

  loadHeaderData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.items && data.data.items.length > 0) {
        //console.log('data : ', data.data);
        this.setState({
          headerItems: data.data.items,
        });
      }
    });
  };

  loadSectionData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.items && data.data.items.length > 0) {
        //console.log('data : ', data.data);
        this.setState({
          items: data.data.items,
        });
      }
    });
  };

  onTabsChange = params => {
    const { sectionData = { id: '' } } = this.props;
    const { isPrime } = this.props;
    const sectionId = sectionData.id;
    this.props.loadAjaxSectionData({ ...params, sectionId, isPrime });
  };

  toggleModal = () => {
    this.setState({
      shouldshowModal: !this.state.shouldshowModal,
    });

    if (!this.state.shouldshowModal) {
      const { sectionData = {} } = this.props;
      sendGaThroughProps({
        data: {
          // gaCategory: ,
          gaAction: `${sectionData.name}Section_CityChange`,
          gaLabel: 'CityChange_Click',
        },
      });
    }
  };

  renderHeader = () => {
    const { shouldshowModal, headerItems } = this.state;
    const { sectionData = {}, geoCityData, geoCityData: { city } } = this.props;
    const sectionName = sectionData.name;
    const headerTabs = this.props.subSections || headerItems;

    return (
      <>
        {sectionData.id &&
          sectionData.subSectionsLayout === 'city_dropdown' && (
            <Listingheader
              headingname={sectionName}
              headingLink={sectionData.link || sectionData.path}
              newga={`${sectionName}Section_Actions#HeadingClick`}
              cityDropdown
              target={sectionData.target}
              ga4Type={sectionData?.ga4Type}
              ga4Category={sectionData?.ga4Category}
            >
              <>
                {shouldshowModal &&
                  sectionData.subSections &&
                  sectionData.subSections.dataUrl && (
                    <CityModal
                      dataUrl={sectionData.subSections.dataUrl}
                      onChangeCallback={this.onTabsChange}
                      // newga={`${
                      //   sectionData.name
                      // }Section_Actions_CityChange#CityChange_`}
                      gaData={{
                        gaAction: `${sectionData.name}Section_CityChange`,
                        partialGaLabel: 'CityChange_',
                      }}
                      geoCityData={geoCityData}
                      toggleModal={this.toggleModal}
                    />
                  )}
                <span>{city}</span>
                <div className={s.changecity} onClick={this.toggleModal}>
                  Change
                </div>
              </>
            </Listingheader>
          )}
        {sectionName && sectionData.subSectionsLayout !== 'city_dropdown' ? (
          <Listingheader
            headingname={sectionName}
            headingLink={sectionData.link || sectionData.path}
            newga={`${sectionName}Section_Actions#HeadingClick`}
            target={sectionData.target}
            ga4Type={sectionData?.ga4Type}
            ga4Category={sectionData?.ga4Category}
            data={sectionData?.data}
          >
            {headerTabs && headerTabs instanceof Array ? (
              <HeaderTab
                subSections={headerTabs}
                onChangeCallback={this.onTabsChange}
                newga={`${sectionData.name}Section_TabChange#Click_`}
                ga4Type={sectionData?.ga4Type}
                ga4Category={sectionData?.ga4Category}
              />
            ) : (
              <Dropdown
                data={sectionData.navigation && sectionData.navigation.sections}
              />
            )}
          </Listingheader>
        ) : null}
      </>
    );
  };

  static renderInfocus(data, secname) {
    return <Infocus title={data.title} data={data.items} secname={secname} />;
  }

  render() {
    const { sectionData = {} } = this.props;
    const listItems = sectionData.items || this.state.items;
    let insertsData;
    let compareWidgetData;
    let latestmobileData;
    let iframeData;
    if (listItems instanceof Array) {
      insertsData = listItems.filter(item => item.inserts instanceof Array);

      if (insertsData[0] && insertsData[0].inserts instanceof Array) {
        compareWidgetData = insertsData[0].inserts.filter(
          item => item.tn === 'comparison',
        )[0];

        latestmobileData = insertsData[0].inserts.filter(
          item => item.tn === 'latestmobile',
        )[0];

        iframeData = insertsData[0].inserts.filter(
          item => item.tn === 'iframe',
        )[0];
      }
    }
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };
    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadNavigationData();
          this.loadSection();
        }}
        viewMargin="500px 0px 500px 0px"
      >
        <div className={s.section_wrapper} {...scrollGAAttr}>
          {sectionData.border &&
            sectionData.border === 'top' && (
              <InterSectionBorder border={sectionData.border} />
            )}
          {sectionData.subSections &&
            sectionData.subSections.dataUrl &&
            this.props.showTechSectionLoader && <LoaderSpinner />}

          {this.renderHeader()}
          <div className={`${'row'}`}>
            <div className={`${'col_l_8 col_m_12 padR32'}  ${s.rhs_border}`}>
              {sectionData &&
                listItems instanceof Array &&
                listItems.map((itemObj = {}) => {
                  const item = itemObj;
                  switch (item.tn) {
                    case 'lead_plus_4_list': {
                      return (
                        <div className={`${'row'} ${s.bottomspacing}`}>
                          <div className="col_l_6 col_m_6">
                            <Card
                              data={item.items[0]}
                              itemClass="col_l_12 col_m_12"
                              isLeadTypeTwo
                              nonFeaturedListWrapperClass="col_l_12 col_m_12"
                              newga={`${
                                sectionData.name
                              }Section_Actions#$typeClick-lead/${_get(
                                item.items[0],
                                'wu',
                                '',
                              )}`}
                              htmlKeys={item.htmlKeys}
                              key={`${sectionData.id}_${item.tn}_${
                                item.items[0]?.wu
                              }`}
                              ga4Type={sectionData?.ga4Type}
                              ga4Category={sectionData?.ga4Category}
                              gaIndex={item.items[0].gaindex}
                            />
                          </div>
                          <div className={`${s.rightNews} col_l_6 col_m_6`}>
                            <LinkList
                              data={item.items.slice(1)}
                              className="linktype1"
                              newga={`${
                                sectionData.name
                              }Section_Actions#$typeClick-$index`}
                              ga4Type={sectionData?.ga4Type}
                              ga4Category={sectionData?.ga4Category}
                            />
                          </div>
                        </div>
                      );
                    }

                    case 'column_2_list': {
                      return (
                        <CardListV5
                          data={item.items}
                          nonFeaturedDisplay={{
                            hideImage: item.hasImage !== '1',
                            itemClass: 'linktype2',
                            itemWrapperClass: 'col_l_3 col_m_3',
                            textItemWrapperClass: 'bdr_right no_bdr_last',
                            listWrapperClass: 'row',
                          }}
                          newga={`${
                            sectionData.name
                          }Section_Actions#$typeClick-`}
                          htmlKeys={item.htmlKeys}
                          key={`${sectionData.id}_${item.tn}`}
                          ga4Type={sectionData?.ga4Type}
                          ga4Category={sectionData?.ga4Category}
                        />
                      );
                    }

                    case 'affiliate_widget':
                      return (
                        <AffiliateWidgetMain
                          isWapView={this.props.isWapView}
                          url={item.dataUrl} //"/feed_affiliate_sponsor_api_react/msid-71422513,title-Top%20Deals,limit-10,tag-toi_hp_bestseller_web_widget-20,feedtype-json.cms"
                          slidesToShow={3.5}
                          slidesToScroll={3}
                          noDataCallBack={() => {
                            this.noDataCallBack('affiliate_widget');
                          }}
                          //updateSlidesForGutterAds
                          key={`${sectionData.id}_${item.tn}`}
                        />
                      );

                    default: {
                      return null;
                    }
                  }
                })}
              {compareWidgetData && compareWidgetData.items ? (
                <CompareWidget
                  name={compareWidgetData.name}
                  path={compareWidgetData.path}
                  items={compareWidgetData.items}
                  ga4Type={sectionData?.ga4Type}
                  ga4Category={sectionData?.ga4Category}
                />
              ) : null}
            </div>

            <div className={`${'col_l_4 hide_m padL32'}`}>
              {latestmobileData && latestmobileData.name ? (
                <Listingheader
                  headingname={latestmobileData.name}
                  headingLink={latestmobileData.link || latestmobileData.path}
                  newga={`${latestmobileData.name}Section_Actions#HeadingClick`}
                  size="small"
                  target={sectionData.target}
                  ga4Type={sectionData?.ga4Type}
                  ga4Category={sectionData?.ga4Category}
                />
              ) : null}
              {latestmobileData && latestmobileData.items instanceof Array
                ? latestmobileData.items.map((item, itemIndex) => (
                    <GadgetCard
                      data={item}
                      doNotChangeURL={
                        item.dnc === '1' || sectionData.dnc === '1'
                      }
                      // showDescription={itemIndex <= leadImageUpperLimit}
                      //isLeadImageNews={itemIndex <= leadImageUpperLimit}
                      isInlineSmallIconCard={itemIndex}
                      //itemClass={itemIndex >= 0 && s.leadspacing}
                      key={`card_${itemIndex}`}
                      target={item.target === '1' || sectionData.target === '1'}
                      linkData={{
                        gaAction: 'gaAction',
                        gaLabel: `ArticleClick/${itemIndex}/${item?.wu}`,
                      }}
                      ga4Type={sectionData?.ga4Type}
                      ga4Category={sectionData?.ga4Category}
                      // isHalfMobileTile={clubStories.indexOf(itemIndex) >= 0}
                    />
                  ))
                : null}
              {iframeData &&
                iframeData.dataUrl && (
                  <div className={`${s.topspacing}`}>
                    <IFrameWdt
                      dataUrl={iframeData.dataUrl}
                      lazy
                      height={iframeData?.height}
                    />
                  </div>
                )}
            </div>
          </div>
          {sectionData.keywords
            ? TechSection.renderInfocus(sectionData.keywords, 'Tech_Infocus')
            : ''}
        </div>
      </InViewObserver>
    );
  }
}
TechSection.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  children: PropTypes.element,
  loadAjaxSectionData: PropTypes.func.isRequired,
  showTechSectionLoader: PropTypes.bool,
  renderInsertsFn: PropTypes.func,
  geoCityData: PropTypes.shape({}),
};

TechSection.defaultProps = {
  isWapView: false,
  children: undefined,
  showTechSectionLoader: false,
  renderInsertsFn: () => {},
  geoCityData: {},
};

export default TechSection;
